export default __webpack_public_path__ + "static/media/Febrero2024(1140x600).c8f7e5b1.webp";